/* Publish by EComposer at 2024-06-26 13:20:27*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vqtc1gn003o"]=  window.__ectimmers["ecom-vqtc1gn003o"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vqtc1gn003o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vqtc1gn003o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zt6ct6a0u3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zt6ct6a0u3g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h5gjk6cwck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h5gjk6cwck', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ar7oan33jwt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ar7oan33jwt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m13s5mkwl7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m13s5mkwl7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ybe14tp2wl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ybe14tp2wl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vda4hg8bixq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vda4hg8bixq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ws7vvfl6w9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ws7vvfl6w9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4xstccitl1v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4xstccitl1v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2gzjnatddbw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2gzjnatddbw', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-anm2iua8qnm"]=  window.__ectimmers["ecom-anm2iua8qnm"] || {};
let e=this.$el;if(!e)return;let i=e.querySelectorAll(":scope > .tabs__wrapper > .tabs__navs > .tabs__navs--items > .tabs__nav"),t=e.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),n=this.settings.action;i.forEach((a,r)=>{n==="click"||window.screen.width<1025?a.onclick=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),o()}:a.onmouseover=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),o()}});function s(){let a=window.location.hash;if(a){let r=e.querySelector(`[data-target="${a}"]`);if(r){r.click();let l=r.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,l)}}}setTimeout(()=>{s()},300);function o(){window.dispatchEvent(new window.Event("resize")),setTimeout(()=>{window.dispatchEvent(new window.Event("resize"))},500)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-anm2iua8qnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-anm2iua8qnm', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}